class MobileMenu {
  constructor() {
    this.menu = document.querySelector(".mobile-navigation")
    this.openButton = document.querySelector(".site-header__menu-trigger")
    this.subMenuToggle = document.querySelectorAll(
      ".mobile-navigation li.menu-item-has-children > a"
    )
    this.subMenu = document.querySelectorAll("li.menu-item-has-children > ul")
    this.events()
  }

  events() {
    this.openButton.addEventListener("click", () => this.openMenu())
    this.subMenuToggle.forEach((item) => {
      item.addEventListener("click", (event) => this.toggleSubMenu(event))
    })
  }

  openMenu() {
    this.openButton.classList.toggle("fa-bars")
    this.openButton.classList.toggle("fa-window-close")
    this.menu.classList.toggle("mobile-navigation__menu--active")
  }

  closeOtherSubMenus(currentSubMenu) {
    this.subMenu.forEach((subMenu) => {
      if (
        subMenu !== currentSubMenu &&
        subMenu.classList.contains("sub-menu--active")
      ) {
        const parentItem = subMenu.parentElement
        const icon = parentItem.querySelector("a::before")

        subMenu.classList.remove("sub-menu--active")
        parentItem.classList.remove("sub-menu-parent--active")
        icon.classList.remove("keyboard_arrow_up")
        icon.classList.add("keyboard_arrow_down")
      }
    })
  }

  toggleSubMenu(event) {
    event.preventDefault()
    console.log("toggleSubMenu")
    const parentItem = event.currentTarget.parentElement
    const subMenu = parentItem.querySelector("ul")
    const icon = parentItem.querySelector("a::after")
    const isSubMenuActive = subMenu.classList.contains("sub-menu--active")

    // Toggle the active states after closing other submenus
    if (!isSubMenuActive) {
      this.closeOtherSubMenus(subMenu) // Close other submenus
      subMenu.classList.add("sub-menu--active")
      parentItem.classList.add("sub-menu-parent--active")
      icon.classList.remove("keyboard_arrow_down")
      icon.classList.add("keyboard_arrow_up")
    } else {
      subMenu.classList.remove("sub-menu--active")
      parentItem.classList.remove("sub-menu-parent--active")
      icon.classList.remove("keyboard_arrow_up")
      icon.classList.add("keyboard_arrow_down")
    }
  }
}

export default MobileMenu
